module.exports = __webpack_public_path__ + "static/media/33000033.9bc22700.jpg";